import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeUserCreate,
  detail: routeUserDetail,
  home: routeUsersHome,
  root: routeUsersRoot,
} = createDoctypeRoutes({
  createName: 'new-user',
  createPath: 'new-user',
  detailName: 'userDetail',
  doctype: DOCTYPES.USER,
  homeName: 'users-home',
  path: 'users',
  views: {
    create: async () => await import('@/components/viewsExternal/settings/users/AddUser.vue'),
    detail: async () => await import('@/components/viewsExternal/settings/users/ViewUser.vue'),
    list: async () => await import('@/components/viewsExternal/settings/users/UserView.vue'),
  },
})

export { routeUserCreate, routeUserDetail, routeUsersHome, routeUsersRoot }
